import { Dialog } from 'primereact/dialog';
import React from 'react';

/**
 * @param {import('primereact/dialog').DialogProps} props
 */
export const ModalDialog = (props) => {
    return <Dialog modal baseZIndex={2001} {...props} />;
};
